<template>
  <v-content class="grey lighten-4">
    <AppBar title="Omlopp" :extension-height="50">
      <template v-slot:extension>
        <v-container class="py-0">
          <v-form @submit.prevent>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  v-model="filter"
                  block
                  dense
                  outlined
                  hide-details
                  class="mb-3"
                  placeholder="Filtrera på fordon/tågnr..."
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </template>
    </AppBar>
    <AppNavigationDrawer />

    <v-container class="px-0 pt-0">
      <transition name="scroll-y-transition" mode="out-in">
        <v-row
          v-if="!loading && data.length"
          class="d-flex flex-column align-center px-4"
        >
          <v-data-table
            :headers="headers"
            :items="filteredData"
            :mobile-breakpoint="0"
            sort-by="timeStart"
            :sort-desc="false"
            class="elevation-1"
            style="width: 100%"
            hide-default-footer
            disable-pagination
            fixed-header
            height="calc(100vh - 120px)"
          >
            <template v-slot:item="{ item }">
              <tr @click="onClickTrip(item.departureDate, item.number)">
                <td colspan="6">
                  <div class="d-flex">
                    <div style="width: 85px; font-weight: bold;">
                      {{ item.number }}
                    </div>
                    <div style="width: 120px">{{ item.place }}</div>
                    <div>{{ item.timeStartEnd }}</div>
                  </div>

                  <div>
                    <div
                      class="caption d-flex grey--text text--darken-1"
                      style="position: relative;"
                    >
                      <div>{{ item.vehicle }}</div>
                      <div style="position: absolute; left: 205px">
                        {{ item.departureDate }}
                      </div>
                    </div>
                  </div>

                  <ActivtyRow :activities="item.activities" type="before" />
                  <ActivtyRow :activities="item.activities" type="after" />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-row>
        <v-row
          no-gutters
          v-else-if="!loading && !data.length"
          class="d-flex flex-column align-center pt-12"
        >
          <v-icon size="50">mdi-information-outline</v-icon>
          <span class="grey--text text--darken-1 mt-4"
            >Ingen data hittades</span
          >
        </v-row>
        <v-row no-gutters v-else class="d-flex flex-column align-center pt-12">
          <div class="d-flex align-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <span class="grey--text text--darken-1 ml-4">Hämtar data...</span>
          </div>
        </v-row>
      </transition>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar'
import AppNavigationDrawer from '@/components/AppNavigationDrawer'
import ActivtyRow from '@/components/ActivtyRow'
import axios from 'axios'
import { get } from 'vuex-pathify'
import { format } from 'date-fns'

export default {
  name: 'Circulations',

  components: {
    AppBar,
    AppNavigationDrawer,
    ActivtyRow
  },

  data: () => ({
    sortBy: 'timeStart',
    sortDesc: false,
    loading: true,
    data: [],
    filter: '',
    headers: [
      { text: 'Tågnr.', value: 'number', width: 85 },
      { text: 'Plats', value: 'place', width: 120 },
      { text: 'Avg.-Ank.', value: 'timeStart' }
    ]
  }),

  created() {
    this.fetch()
  },

  watch: {
    districtId() {
      this.fetch()
    }
  },

  computed: {
    districtId: get('sso/districtId'),

    filteredData() {
      return this.data.filter(x => {
        return (
          !this.filter.length ||
          x.vehicle.toLowerCase().includes(this.filter) ||
          x.number.toString().includes(this.filter)
        )
      })
    }
  },

  methods: {
    onClickTrip(departureDate, number) {
      if (!departureDate || !number) return
      this.$router.push(`/crew/${departureDate}/${number}`)
    },

    async fetch() {
      this.loading = true
      const { data } = await axios.get(
        `https://arriva-integration-platform.reges.io/arriva/kalender-avgangar/1?district=${this.districtId}`,
        {
          headers: {
            Authorization: `Basic c3ZjLXRyYWluZC1hcnJpdmEtMDFAcmVnZXMuc2U6QT04L2RjfWhlOkJWYCRUdA==`
          }
        }
      )

      this.data = data.map(x => ({
        ...x,
        place: `${x.placeStart} - ${x.placeEnd}`,
        vehicle: `${x.vehicle}${x.position ? ` M${x.position}` : ''}`,
        timeStartEnd: `${format(new Date(x.timeStart), 'HH:mm')} - ${format(
          new Date(x.timeEnd),
          'HH:mm'
        )}`
      }))

      this.loading = false
    }
  }
}
</script>
